<template>
	<div id="systemSettings">
		<div class="main">
			<h1 class="title">PC 端隐私政策</h1>
			<div class="content">
				<h4>生效日期：2025年3月12日</h4>
				<p>欢迎使用我们的 PC 端服务！本隐私政策旨在帮助您了解我们如何收集、使用、存储和共享您在使用我们 PC
					端服务时提供的个人信息，以及您所享有的权利。请您在使用我们的服务前，仔细阅读并理解本隐私政策的内容。</p>
				<h4>一、定义</h4>
				<p>个人信息：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。</p>
				<p>个人敏感信息：指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息，包括但不限于身份证号码、银行卡信息、生物识别信息等。</p>
				<p>我们：升学就业在线科技股份有限公司及其关联公司。</p>
				<p>PC 端服务：指我们通过 PC 端应用程序、网站等向您提供的各项服务。</p>
				<h4>二、我们如何收集您的个人信息</h4>
				<p>（一）注册与登录</p>
				<p>当您注册或登录我们的 PC 端服务时，我们会收集您的用户名、密码、手机号码等信息，用于创建和管理您的账户，保障您的账户安全。</p>
				<p>若您选择使用第三方账号（如微信、QQ 等）登录，我们会从第三方获取您授权共享的账户信息（如昵称、头像等），并与我们的服务进行关联。</p>
				<p>（二）使用服务过程中</p>
				<p>设备信息：我们会收集您使用的 PC 设备型号、操作系统版本、浏览器类型、IP 地址等信息。</p>
				<!-- ，以便为您提供更好的服务体验，优化我们的产品性能，保障服务安全。 -->
				<p>日志信息：我们不会自动收集您的操作日志，包括浏览记录、搜索记录、点击行为等。</p>
				<!-- ，用于分析您的使用习惯，改进服务质量，为您提供个性化的服务推荐。 -->
				<p>交互信息：当您与我们的客服沟通、参与社区互动（如评论、发帖等）时，我们会收集您提供的文字、图片、语音等信息，以处理您的咨询、反馈，维护社区秩序。</p>
				<!-- <p>（三）其他方式</p>
						<p>问卷调查：在部分情况下，我们可能会通过问卷调查的方式收集您的意见和建议，问卷中可能涉及您的个人信息，您可以自愿选择是否参与。</p>
						<p>合作伙伴共享：我们可能从合作伙伴处获得您的个人信息，例如当您通过合作伙伴的渠道使用我们的服务时，合作伙伴可能会向我们提供您的相关信息，我们会按照与合作伙伴的约定及本隐私政策的规定处理这些信息。</p> -->
				<h4>三、我们如何使用您的个人信息</h4>
				<p>提供服务：我们使用您的个人信息为您提供 PC 端服务，包括账户管理、内容展示、功能使用等。</p>
				<p>个性化推荐：基于您的使用习惯和偏好，我们会使用您的个人信息为您提供个性化的内容推荐、服务推荐，提升您的使用体验。</p>
				<p>改进服务：通过分析您的个人信息和使用数据，我们可以了解服务的使用情况，发现问题并进行改进，优化产品功能和性能。</p>
				<p>安全保障：我们使用您的个人信息保障服务的安全运行，防范安全风险，识别和处理欺诈、侵权等违法行为。</p>
				<p>法律合规：在必要时，我们可能会根据法律法规的要求，使用您的个人信息进行合规性审查、审计等。</p>
				<h4>四、我们如何存储您的个人信息</h4>
				<p>存储地点：我们将您的个人信息存储在中华人民共和国境内。如因业务需要，确需向境外传输的，我们会按照法律法规的规定，履行相应的程序并采取有效的保护措施。</p>
				<p>存储期限：我们会根据业务需要和法律法规的规定，确定您个人信息的存储期限。在您的账户存续期间，我们会持续保留您的必要个人信息。在您注销账户后，我们会按照规定删除或匿名化处理您的个人信息，但法律法规另有规定的除外。
				</p>
				<h4>五、我们如何共享、转让、公开披露您的个人信息</h4>
				<p>（一）共享</p>
				<p>我们不会向第三方共享您的个人信息，除非获得您的明确同意。</p>
				<p>在以下情形下，我们可能会与第三方共享您的个人信息：</p>
				<p>为提供服务之必要，与合作伙伴（如技术服务提供商、数据分析机构等）共享，且我们会要求合作伙伴遵守严格的保密义务，仅在授权范围内使用您的个人信息。</p>
				<h4>生效日期：2025年3月12日</h4>
				<p>欢迎使用我们的 PC 端服务！本隐私政策旨在帮助您了解我们如何收集、使用、存储和共享您在使用我们 PC
					端服务时提供的个人信息，以及您所享有的权利。请您在使用我们的服务前，仔细阅读并理解本隐私政策的内容。</p>
				<h4>一、定义</h4>
				<p>个人信息：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。</p>
				<p>个人敏感信息：指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息，包括但不限于身份证号码、银行卡信息、生物识别信息等。
				</p>
				<p>我们：升学就业在线科技股份有限公司及其关联公司。</p>
				<p>PC 端服务：指我们通过 PC 端应用程序、网站等向您提供的各项服务。</p>
				<h4>二、我们如何收集您的个人信息</h4>
				<p>（一）注册与登录</p>
				<p>当您注册或登录我们的 PC 端服务时，我们会收集您的用户名、密码、手机号码等信息，用于创建和管理您的账户，保障您的账户安全。</p>
				<p>若您选择使用第三方账号（如微信、QQ 等）登录，我们会从第三方获取您授权共享的账户信息（如昵称、头像等），并与我们的服务进行关联。</p>
				<p>（二）使用服务过程中</p>
				<p>设备信息：我们会收集您使用的 PC 设备型号、操作系统版本、浏览器类型、IP 地址等信息，以便为您提供更好的服务体验，优化我们的产品性能，保障服务安全。</p>
				<p>日志信息：在您使用服务过程中，我们会自动收集您的操作日志，包括浏览记录、搜索记录、点击行为等，用于分析您的使用习惯，改进服务质量，为您提供个性化的服务推荐。</p>
				<p>交互信息：当您与我们的客服沟通、参与社区互动（如评论、发帖等）时，我们会收集您提供的文字、图片、语音等信息，以处理您的咨询、反馈，维护社区秩序。</p>
				<p>（三）其他方式</p>
				<p>问卷调查：在部分情况下，我们可能会通过问卷调查的方式收集您的意见和建议，问卷中可能涉及您的个人信息，您可以自愿选择是否参与。</p>
				<p>合作伙伴共享：我们可能从合作伙伴处获得您的个人信息，例如当您通过合作伙伴的渠道使用我们的服务时，合作伙伴可能会向我们提供您的相关信息，我们会按照与合作伙伴的约定及本隐私政策的规定处理这些信息。
				</p>
				<h4>三、我们如何使用您的个人信息</h4>
				<p>提供服务：我们使用您的个人信息为您提供 PC 端服务，包括账户管理、内容展示、功能使用等。</p>
				<p>个性化推荐：基于您的使用习惯和偏好，我们会使用您的个人信息为您提供个性化的内容推荐、服务推荐，提升您的使用体验。</p>
				<p>改进服务：通过分析您的个人信息和使用数据，我们可以了解服务的使用情况，发现问题并进行改进，优化产品功能和性能。</p>
				<p>安全保障：我们使用您的个人信息保障服务的安全运行，防范安全风险，识别和处理欺诈、侵权等违法行为。</p>
				<p>法律合规：在必要时，我们可能会根据法律法规的要求，使用您的个人信息进行合规性审查、审计等。</p>
				<h4>四、我们如何存储您的个人信息</h4>
				<p>存储地点：我们将您的个人信息存储在中华人民共和国境内。如因业务需要，确需向境外传输的，我们会按照法律法规的规定，履行相应的程序并采取有效的保护措施。</p>
				<p>存储期限：我们会根据业务需要和法律法规的规定，确定您个人信息的存储期限。在您的账户存续期间，我们会持续保留您的必要个人信息。在您注销账户后，我们会按照规定删除或匿名化处理您的个人信息，但法律法规另有规定的除外。
				</p>
				<h4>五、我们如何共享、转让、公开披露您的个人信息</h4>
				<p style="color: #464646;">（一）共享</p>
				<p>我们不会向第三方共享您的个人信息，除非获得您的明确同意。</p>
				<p>在以下情形下，我们可能会与第三方共享您的个人信息：</p>
				<p>为提供服务之必要，与合作伙伴（如技术服务提供商、数据分析机构等）共享，且我们会要求合作伙伴遵守严格的保密义务，仅在授权范围内使用您的个人信息。</p>
				<p>根据法律法规的规定或有权机关的要求，需要向第三方披露的。</p>
				<p style="color: #464646;">（二）转让</p>
				<p>我们不会将您的个人信息转让给第三方，除非获得您的明确同意。如因公司合并、分立、破产清算等原因需要转让个人信息的，我们会要求受让方遵守本隐私政策或另行征得您的同意。
				</p>
				<p style="color: #464646;">（三）公开披露</p>
				<p>我们不会公开披露您的个人信息，除非获得您的明确同意或根据法律法规的规定、有权机关的要求进行公开披露。</p>
				<h4>六、您的权利</h4>
				<p>访问权：您有权访问您的个人信息，包括账户信息、使用记录等。您可以通过我们 PC 端服务的相关设置或联系客服进行查询。</p>
				<p>更正权：如果您发现您的个人信息存在错误或不完整，您有权要求我们进行更正。您可以通过服务内的操作指引或联系客服进行更正。</p>
				<p>删除权：在符合法律法规规定的情形下，您有权要求我们删除您的个人信息。例如，当您的个人信息不再为实现服务目的所必要时，您可以向我们提出删除请求。
				</p>
				<p>注销权：您有权随时注销您的账户。注销账户后，我们将按照规定删除或匿名化处理您的个人信息。您可以通过服务内的注销流程或联系客服进行账户注销。</p>
				<p>撤回同意权：对于您已同意我们收集和使用的个人信息，您有权随时撤回同意。撤回同意后，我们将不再基于该同意处理您的个人信息，但不影响之前基于同意已进行的处理行为。
				</p>
				<p>获取个人信息副本权：在符合法律法规规定的情况下，您有权获取您个人信息的副本。您可以联系客服申请获取。</p>
				<h4>七、我们如何保护您的个人信息安全</h4>
				<p>我们采取技术措施和管理措施，保障您的个人信息安全，防止个人信息泄露、丢失、被篡改或滥用。</p>
				<p>我们对员工进行信息安全培训，使其严格遵守保密义务和操作规程。</p>
				<p>我们制定了信息安全事件应急预案，在发生信息安全事件时，我们会立即启动应急预案，采取措施降低损失，并按照法律法规的要求及时通知您。</p>
				<h4>八、未成年人保护</h4>
				<p>我们的服务主要面向成年人。若您是未成年人，在使用我们的服务前，请您的父母或监护人仔细阅读本隐私政策，并在征得他们的同意后使用我们的服务。
				</p>
				<p>我们会采取措施保护未成年人的个人信息安全，如限制未成年人的注册和使用权限，避免收集未成年人的敏感个人信息等。若我们发现未经监护人同意而收集了未成年人的个人信息，我们会尽快删除相关信息。
				</p>
				<h4>九、隐私政策的更新</h4>
				<p>我们可能会根据业务发展、法律法规变化等情况适时更新本隐私政策。更新后的隐私政策将在我们的 PC
					端服务上公布，您可以随时查看。</p>
				<p>对于重大变更，我们会通过显著方式（如弹窗、推送通知等）向您提示。在您继续使用我们的服务前，请仔细阅读更新后的隐私政策，若您不同意更新后的政策，您有权停止使用我们的服务。
				</p>
				<h4>十、联系我们</h4>
				<p>如果您对本隐私政策或个人信息保护有任何疑问、意见或建议，您可以通过以下方式联系我们：</p>
				<p>客服邮箱：13387651949@163.com</p>
				<p>客服电话：13387651949</p>

			</div>
		</div>
	</div>
</template>
<script>
	import {
		mapMutations
	} from 'vuex'
	export default {
		data() {
			return {
			};
		},
		mounted() {
			// this.$util.post(
			// 	"/login/login", {
			// 		username: this.ruleForm.username,
			// 		password: this.$md5(this.ruleForm.pass),
			// 	},
			// 	(res) => {
			// 		
			// 		if (res.code == 1) {
			// 			localStorage.setItem("token", res.data.token);
			// 			this.$router.push({
			// 				path: "/main",
			// 				// query: {
			// 				//   id: 1,
			// 				// },
			// 			});
			// 		}
			// 	}
			// );
		},
		methods: {
			...mapMutations(['setIslogin']),

		},
		components: {},
	};
</script>
<style lang="less" scoped>
	body {
		background: #fff;
		font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Noto Sans CJK SC, WenQuanYi Micro Hei, Arial, sans-serif;
		padding: 0px;
		margin: 0px;
	}

	.main {
		width: 1200px;
		margin: 0px auto;
	}

	h1,
	h4 {
		color: #333;
		font-family: 'PingFang SC', '微软雅黑', 'YaHei', '黑体', 'Hei', Tahoma, Helvetica, arial, sans-serif;
	}

	p {
		font-size: 13px;
		line-height: 1.6;
		color: #999;
	}

	.title {
		font-size: 32px;
		font-weight: normal;
		padding: 30px 0;
		border-bottom: 1px solid #ececec;
		position: relative;
		margin-bottom: 30px;
	}

	.content p {
		font-size: 14px;
		font-weight: normal;
		margin: 10px 0;
		color: #464646;
	}

	.content h4 {
		font-size: 16px;
		font-weight: normal;
		color: #232323;
	}
</style>